<div class="editRoles__container">
    <div class="editRoles__header">
        <div class="editRoles__title">
            <ng-container [ngSwitch]="mode">
                <ng-container *ngSwitchCase="'create'">Create Workflow</ng-container>
                <ng-container *ngSwitchCase="'update'">Edit {{ workflowData?.name }}</ng-container>
                <ng-container *ngSwitchCase="'view'">{{ workflowData?.name }}</ng-container>
                <ng-container *ngSwitchDefault>Workflow</ng-container>
            </ng-container>
        </div>
        <div class="editRoles__crossIcon" (click)="handleClosePopup({isClose : true})">
            <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
        </div>
    </div>
    <div class="workflowForm__contentWrapper">
        <form [formGroup]="workflowForm">

            <div class="d-flex row align-items-baseline">
                <div class="col-md-4">
                    <ng-container *ngIf="mode !== 'view'">
                        <app-input-filed placeholder="Enter Name" label="Name"
                            [control]="$any(workflowForm).controls['name']"
                            [value]="$any(workflowForm).controls['name'].value" name="name"
                            [starIcon]="'*'"></app-input-filed>
                        <div *ngIf="workflowForm.controls?.['name']?.invalid &&
                                (workflowForm.controls?.['name']?.dirty ||
                                workflowForm.controls?.['name']?.touched)" class="alert_required">
                            <div *ngIf="workflowForm.controls?.['name']?.errors?.['required']">
                                <small class="text-danger">Name is
                                    required.</small>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mode === 'view'">
                        <div class="select_dropdown">
                            <div class="select_dropdownLabel">
                                Name
                            </div>
                            <div class="input-fieldValue">{{ workflowData?.name }}</div>
                        </div>

                    </ng-container>

                </div>
                <div class="col-md-4">
                    <ng-container *ngIf="mode !== 'view'">
                        <div class="select_dropdown">
                            <div class="select_dropdownLabel">
                                Document Category<span style="color: chocolate;">*</span>
                            </div>
                            <select class="select_dropdownOptions" formControlName="documentType">
                                <option [value]="''" selected disabled>Select Document Category
                                </option>
                                <option *ngFor="let item of documentCategoryData" [ngValue]="item?._id">
                                    {{ item?.name }}
                                </option>
                            </select>
                            <div *ngIf="workflowForm.controls?.['documentType']?.invalid &&
                                (workflowForm.controls?.['documentType']?.dirty ||
                                workflowForm.controls?.['documentType']?.touched)" class="alert_required">
                                <div *ngIf="workflowForm.controls?.['documentType']?.errors?.['required']">
                                    <small class="text-danger">Document Category is
                                        required.</small>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mode === 'view'">
                        <div class="select_dropdown">
                            <div class="select_dropdownLabel">
                                Document Category
                            </div>
                            <div class="input-fieldValue">{{ workflowData?.documentType?.name }}</div>
                        </div>

                    </ng-container>
                </div>
                <div class="col-md-4">
                    <ng-container *ngIf="mode !== 'view'">
                        <app-input-filed placeholder="Enter description" label="Description"
                            [control]="$any(workflowForm).controls['description']"
                            [value]="$any(workflowForm).controls['description'].value" name="description"
                            [starIcon]="'*'"></app-input-filed>
                        <div *ngIf="workflowForm.controls?.['description']?.invalid &&
                                (workflowForm.controls?.['description']?.dirty ||
                                workflowForm.controls?.['description']?.touched)" class="alert_required">
                            <div *ngIf="workflowForm.controls?.['description']?.errors?.['required']">
                                <small class="text-danger">Description is
                                    required.</small>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mode === 'view'">
                        <div class="select_dropdown">
                            <div class="select_dropdownLabel">
                                Description
                            </div>
                            <div class="input-fieldValue">{{ workflowData?.description }}</div>
                        </div>

                    </ng-container>

                </div>
            </div>

            <div>
                <div class="stage-header">
                    <h2 class="stage-title">Authorization Stages
                        <span class="file-icon" placement="right" data-bs-toggle="tooltip" [ngbTooltip]="'Either Department or Users is mandatory to select for each stage.'">
                            <app-common-icon [faIcon]="faInfoCircle"></app-common-icon>
                        </span>
                    </h2>
                </div>

                <div formArrayName="stages">
                    <div *ngFor="let stage of stages.controls; let i = index let last = last" [formGroupName]="i"
                        class="stage-box">

                        <div class="stage-container">
                            <div class="d-flex align-items-center justify-content-between">
                                <div *ngIf="mode !== 'view'" class="stage-subtitle">
                                    <!-- Stage {{ i + 1 }} -->
                                </div>
                                <div class="d-flex gap-2" *ngIf="mode !== 'view'">
                                    <div *ngIf="stages.length > 1" class=" text-center">
                                        <fa-icon [icon]="faTrash" class="delete_faicon" (click)="removeStage(i)">
                                        </fa-icon>
                                    </div>
                                    <div *ngIf="last" class=" text-center">
                                        <fa-icon [icon]="faSquarePlus" class="delete_faicon" (click)="addStage()">
                                        </fa-icon>
                                        <!-- <app-common-button buttonClass="smallWidthAuto" [loadingIcon]="false"
                                            buttonLabel="+ Add Stage " (clickEvent)="addStage()"></app-common-button> -->
                                    </div>

                                </div>

                            </div>
                            <div class="row d-flex align-items-baseline">

                                <div class="col-md-4">
                                    <ng-container *ngIf="mode !== 'view'">
                                        <app-input-filed placeholder="Enter Name" label="Name"
                                            [control]="$any(stageControls(i)).controls['name']" name="name"
                                            [value]="$any(stageControls(i)).controls['name'].value"
                                            [starIcon]="'*'"></app-input-filed>
                                        <div *ngIf="stageControls(i).controls['name']?.invalid &&
                                        (stageControls(i).controls['name']?.dirty ||
                                        stageControls(i).controls['name']?.touched)" class="alert_required">
                                            <div *ngIf="stageControls(i).controls['name']?.errors?.['required']">
                                                <small class="text-danger">Name is
                                                    required.</small>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="mode === 'view'">
                                        <div class="select_dropdown">
                                            <div class="select_dropdownLabel">
                                                Name
                                            </div>
                                            <div class="input-fieldValue">
                                                {{workflowData?.stages[i]?.name}}</div>
                                        </div>

                                    </ng-container>

                                </div>

                                <div class="col-md-4">
                                    <ng-container *ngIf="mode !== 'view'">

                                        <div class="select_dropdown">
                                            <div class="select_dropdownLabel">
                                                Department
                                            </div>
                                            <select class="select_dropdownOptions" formControlName="department" (change)="onDepartmentChange(i)">
                                                <option [value]="''" selected>Select Department
                                                </option>
                                                <option *ngFor="let item of departmentsData" [ngValue]="item?._id">
                                                    {{ item?.name }}
                                                </option>
                                            </select>
                                            <div *ngIf="stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched" class="alert_required">
                                                    <small class="text-danger">Please select atleast one Department or Users</small>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="mode === 'view'">
                                        <div class="select_dropdown">
                                            <div class="select_dropdownLabel">
                                                Department
                                            </div>
                                            <div class="input-fieldValue">
                                                {{workflowData?.stages[i]?.departments[0]?.departmentName}}</div>
                                        </div>
                                    </ng-container>

                                </div>

                                <div class="col-md-4">
                                    <ng-container *ngIf="mode !== 'view'">
                                
                                        <div class="select_dropdown">
                                            <div class="select_dropdownLabel">
                                                Users
                                            </div>
                                            <app-auto-search-dropdown style="position: relative;" placeholder="Users"  (click)="getUsersList(i)" [isMultiSelect]="true" (selectedValues)="onSelectUser(i, $event)"  formControlName="users"
                                               [previousSeletedValues]="stageControls(i).controls['users']?.value" (loadMore)="getUsersList(i)" [listData]="usersList" (searchText)="getUsersList(i, $event)">
                                            </app-auto-search-dropdown>
                                            <div *ngIf="stageControls(i).errors?.['atLeastOneSelect'] && stageControls(i).touched" class="alert_required">
                                                    <small class="text-danger">Please select atleast one Department or Users</small>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="mode === 'view'">
                                        <div class="select_dropdown">
                                            <div class="select_dropdownLabel">
                                                Users
                                            </div>
                                            <div class="input-fieldValue">
                                                {{ workflowData?.stages[i]?.users?.length > 0
                                                ? workflowData?.stages[i]?.users[0]?.name + ' (' + workflowData?.stages[i]?.users[0]?.emailAddress + ')'
                                                : '-' }}
                                                <span *ngIf="workflowData?.stages[i]?.users?.length > 0" class="dots" data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    +more
                                                </span>
                                                <ul class="dropdown-menu">
                                                    <li class="dropdown-item" *ngFor="let user of workflowData?.stages[i]?.users">{{user?.name +'
                                                        ('+user?.emailAddress+')'}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                            </div>  

                            <div class="row d-flex align-items-baseline pt-3" formGroupName="notifications">

                                        <div class="select_dropdown col-md-4">
                                            <ng-container *ngIf="mode !== 'view'">
                                                <div class="select_dropdownLabel">
                                                    Remainder Type<span style="color: chocolate;">*</span>
                                                </div>
                                                <select class="select_dropdownOptions" formControlName="reminderType">
                                                    <option [value]="''" selected disabled>Select Remainder Type
                                                    </option>
                                                    <option *ngFor="let item of remainderTypeData"
                                                        [ngValue]="item?.value">
                                                        {{ item?.name }}
                                                    </option>
                                                </select>
                                                <div *ngIf="stageControls(i).get('notifications')?.controls['reminderType']?.invalid &&
                                            (stageControls(i).get('notifications')?.controls['reminderType']?.dirty ||
                                            stageControls(i).get('notifications')?.controls['reminderType']?.touched)"
                                                    class="alert_required">
                                                    <div
                                                        *ngIf="stageControls(i).get('notifications')?.controls['reminderType']?.errors?.['required']">
                                                        <small class="text-danger">Remainder Type is
                                                            required.</small>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="mode === 'view'">
                                                <div class="select_dropdownLabel">
                                                    Remainder Type
                                                </div>
                                                <div class="input-fieldValue">
                                                    {{$any(stageControls(i)).get('notifications').controls['reminderType'].value | titlecase}}
                                                </div>
                                            </ng-container>
                                        </div>


                                        <div class="col-md-4">
                                            <ng-container *ngIf="mode !== 'view'">

                                                <app-input-filed placeholder="Reminder Period" label="Reminder Period"
                                                    [control]="$any(stageControls(i)).get('notifications').controls['reminderPeriod']"
                                                    [value]="$any(stageControls(i)).get('notifications').controls['reminderPeriod'].value"
                                                    name="numberOfDays" [starIcon]="'*'">
                                                </app-input-filed>
                                                <div *ngIf="stageControls(i).get('notifications').controls['reminderPeriod']?.invalid &&
                                        (stageControls(i).get('notifications').controls['reminderPeriod']?.dirty ||
                                        stageControls(i).get('notifications').controls['reminderPeriod']?.touched)"
                                                    class="alert_required">
                                                    <div
                                                        *ngIf="stageControls(i).get('notifications').controls['reminderPeriod']?.errors?.['required']">
                                                        <small class="text-danger">Reminder Period is
                                                            required.</small>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="mode === 'view'">
                                                <div class="select_dropdown">
                                                    <div class="select_dropdownLabel">
                                                        Reminder Period
                                                    </div>
                                                    <div class="input-fieldValue">{{
                                                        $any(stageControls(i)).get('notifications').controls['reminderPeriod'].value
                                                        }}</div>
                                                </div>

                                            </ng-container>

                                        </div>
                                    </div>

                        </div>

                    </div>
                </div>
            </div>
        </form>

    </div>
    <div class="editRoles__footer">
            <div class="d-flex  gap-2">
                <app-common-button  buttonClass="smallbutton"
                    buttonLabel="Cancel" (click)="handleClosePopup({isClose : true})"></app-common-button>
                <app-common-button type="button" *ngIf="commonService.orgLock() && mode !== 'view'" [loadingIcon]="verifyLoader" 
                    buttonClass="smallFilledButton" buttonLabel="Submit" 
                    [disabled]="!workflowForm.valid" (clickEvent)="onSubmit()"
                    ></app-common-button>
            </div>
    </div>
</div>

<app-error-toaster *ngIf="showErorToaster" [title]="toasterMessage" (closeToaster)="closeToaster()"></app-error-toaster>